<script>
import {account as columns} from '../../tables'

export default {
  props: {
    path: {
      type: String,
      required: true
    },
    biller: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      columns,
      form: this.$form.createForm(this),
      items: {},
      loading: false,
      expand: false,
      filters: {
        page: 1,
        q: ''
      }
    }
  },
  created() {
    this.items = this.getDefaultPagination()
    this.filters = _.merge(this.filters, this.$hyperion.request)
    this.getItems()
  },

  methods: {
    tableChanged(pagination) {
      this.filters.page = pagination.current
      this.pushState(this.filters)
      this.getItems()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.pushState(this.filters)
      this.getItems()
    },
    handleReset(e) {
      e.preventDefault()
      this.filters = {
        q: null,
        page: 1
      }
    },
    getItems() {
      this.loading = true
      this.$http.get(this.path, {
        params: this.filters
      })
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    }
  }
}
</script>
<template>
  <a-card type="inner" size="small">
    <a-skeleton active :loading="loading">
      <a-table :columns="columns"
               :dataSource="items.data"
               rowKey="hash"
               :pagination="{ current: items.current_page, total: items.total}"
               @change="tableChanged">

        <h4 slot="product" slot-scope="record">
          {{ record.product_group ? record.product_group.name : 'ALL' }}
        </h4>

        <h4 slot="sponsor_fee_threshold" slot-scope="record">
          <currency :amount="record.sponsor_fee_threshold" />
        </h4>

        <div slot="action" class="text-right" slot-scope="record">
          <a-tooltip title="Edit Account">
            <a-button size="small" type="primary" icon="edit" :href="routeUri('hyperion.biller.account.edit', { biller_hash: biller, account:record.id })"/>
          </a-tooltip>
        </div>
      </a-table>
    </a-skeleton>
  </a-card>
</template>
